import { AnimatePresence, motion } from 'motion/react';

import { Button, Input, LabelWithoutRef } from '@app-evolution-cms/element-ui';

interface CustomizationToolbarProps {
  id?: string;
  isEditMode: boolean;
  newGroupLabel: string;
  onToggleEditMode: VoidFunction;
  onGroupLabelChange: (label: string) => void;
  onAddGroup: VoidFunction;
}

export function CustomizationToolbar({
  id,
  isEditMode,
  newGroupLabel,
  onToggleEditMode,
  onGroupLabelChange,
  onAddGroup,
}: CustomizationToolbarProps) {
  return (
    <div>
      <div className="flex justify-end p-2 py-[2px]">
        <Button
          id={id ? `${id}-editMenu-toggle` : undefined}
          className="h-auto px-1"
          size="xs"
          variant="link"
          onClick={onToggleEditMode}
        >
          {isEditMode ? 'Finalizar personalización' : 'Personalizar menú'}
        </Button>
      </div>

      <AnimatePresence initial={false}>
        {isEditMode && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2, ease: 'easeInOut' }}
            style={{ overflow: 'hidden' }}
          >
            <div className="mt-2 grid rounded-3xl rounded-b-none bg-muted px-2 pt-5 pb-3">
              <LabelWithoutRef className="px-4">Nombre de la sección</LabelWithoutRef>
              <p className="px-4 text-xs text-muted-foreground">
                Crea una nueva sección para organizar mejor tus módulos
              </p>
              <form
                className="mt-2 flex gap-2 px-[2px]"
                onSubmit={(e) => {
                  e.preventDefault();
                  onAddGroup();
                }}
              >
                <Input
                  sizesx="sm"
                  className="mr-[2px]"
                  id={id ? `${id}-add-group-input` : undefined}
                  onChange={(e) => onGroupLabelChange(e.target.value)}
                  placeholder="Favoritos, 🐸 Mis módulos"
                  value={newGroupLabel}
                />
                <Button
                  className="w-[4rem] flex-none"
                  size="sm"
                  id={id ? `${id}-add-group-button` : undefined}
                  type="submit"
                >
                  Crear
                </Button>
              </form>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
